export default function isFutureDate(dateStr: string): boolean {
	const inputDate = new Date(dateStr);
	const today = new Date();
	inputDate.setUTCHours(0, 0, 0, 0);
	today.setUTCHours(0, 0, 0, 0);

	return inputDate > today;
}
